import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../components/ui/Card';
import { PublicPageLayout } from '../components/ui/PublicPageLayout';

export const ShippingPolicyPage: React.FC = () => {
  return (
    <PublicPageLayout className="py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <Link
            to="/"
            className="text-indigo-600 dark:text-indigo-400 hover:text-indigo-700 dark:hover:text-indigo-300 font-medium"
          >
            ← Back to Home
          </Link>
        </div>

        <Card className="p-8">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-8">Shipping Policy</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              <strong>Company:</strong> TECKVINI SOLUTIONS PRIVATE LIMITED<br/>
              <strong>Last updated:</strong> {new Date().toLocaleDateString()}
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Digital Service Delivery</h2>
              <div className="text-gray-700 dark:text-gray-200 space-y-4">
                <p>
                  IntFinder is a digital service platform that provides instant access to data search 
                  capabilities. Since our services are delivered digitally, there are no physical products 
                  to ship.
                </p>
                <p>
                  Upon successful payment, you will immediately receive:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Int Coins credited to your account</li>
                  <li>Instant access to all search features</li>
                  <li>Email confirmation of your purchase</li>
                  <li>Access to your account dashboard</li>
                </ul>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Service Availability</h2>
              <div className="text-gray-700 dark:text-gray-200 space-y-4">
                <p>
                  Our services are available 24/7 worldwide. There are no geographical restrictions 
                  on accessing our platform, and all features are delivered instantly upon account 
                  activation.
                </p>
                <p>
                  <strong>Service Delivery Time:</strong> Immediate (within seconds of payment confirmation)
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Account Activation</h2>
              <div className="text-gray-700 dark:text-gray-200 space-y-4">
                <p>
                  Your IntFinder account is activated immediately upon registration. When you purchase 
                  Int Coins:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Credits are added to your account instantly</li>
                  <li>You can start searching immediately</li>
                  <li>No waiting period or processing time</li>
                  <li>Full access to all purchased features</li>
                </ul>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Technical Requirements</h2>
              <div className="text-gray-700 dark:text-gray-200 space-y-4">
                <p>
                  To access our services, you need:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Internet connection</li>
                  <li>Web browser (Chrome, Firefox, Safari, Edge)</li>
                  <li>Valid email address for account verification</li>
                  <li>Payment method for purchasing Int Coins</li>
                </ul>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Service Updates</h2>
              <div className="text-gray-700 dark:text-gray-200 space-y-4">
                <p>
                  We continuously improve our services and may release updates that enhance functionality. 
                  These updates are delivered automatically and do not require any action from you.
                </p>
                <p>
                  <strong>Maintenance Windows:</strong> We perform scheduled maintenance during low-usage 
                  periods, typically with advance notice via email.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Contact Information</h2>
              <div className="text-gray-700 dark:text-gray-200 space-y-4">
                <p>
                  If you have any questions about our service delivery or need assistance with your account, 
                  please contact us:
                </p>
                <div className="bg-gray-100 dark:bg-gray-800 p-4 rounded-lg">
                  <p><strong>Email:</strong> support@intfinder.com</p>
                  <p><strong>Response Time:</strong> Within 24 hours</p>
                  <p><strong>Live Chat:</strong> Available on our website</p>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Company Information</h2>
              <div className="text-gray-700 dark:text-gray-200 space-y-4">
                <p>
                  <strong>Company Name:</strong> TECKVINI SOLUTIONS PRIVATE LIMITED<br/>
                  <strong>Product:</strong> IntFinder<br/>
                  <strong>Contact:</strong> For any shipping-related questions, please contact us at support@intfinder.com
                </p>
              </div>
            </section>
          </div>
        </Card>
      </div>
    </PublicPageLayout>
  );
};
